import { VisitInteractor, VisitRequest, VisitStructRequest } from "../../Coordinator/Visit/VisitInteractor";
import moment from 'moment';

export class VisitViewModel {
  private interactor: VisitInteractor;

  constructor() {
    this.interactor = new VisitInteractor();
  }

  public fetchSave(obj: any, isEndemic: boolean): PromiseLike<any> {
    let request: any
    request = new VisitRequest(
      obj["sgepvisita"] ? parseInt(obj["sgepvisita"]) : 0,
      obj["data"] ? moment(obj["data"], 'DD/MM/YYYY').format('YYYY-MM-DD') : "",
      obj["hora"] ? moment(obj["hora"], 'HH:mm').format('HH:mm:ss') : "",
      obj["sgepusuariocargo"] ? parseInt(obj["sgepusuariocargo"]) : 0,
      obj["sgepmotivovisita"] ? parseInt(obj["sgepmotivovisita"]) : 0,
      obj["obs"] ? obj["obs"] : "",
      obj["sgeppontos"] ? parseInt(obj["sgeppontos"]) : 0,
      obj["sshape"] ? parseInt(obj["sshape"]) : 0,
      obj["sgepprocessoadministrativo"] ? parseInt(obj["sgepprocessoadministrativo"]) : 0,
      obj["sgeppropriedade"] ? parseInt(obj["sgeppropriedade"]) : 0,
      obj["sgeppropedificacoes"] ? parseInt(obj["sgeppropedificacoes"]) : 0
    )
    if (isEndemic) {
      request = {
        ...request,
        sgepatividadedengue: obj["sgepatividadedengue"] ? parseInt(obj["sgepatividadedengue"]) : null,
        ccidade: obj["ccidade"] ? parseInt(obj["ccidade"]) : null,
        ciclo: obj["ciclo"] ? obj["ciclo"] : '',
        concluido: obj["concluido"] ? obj["concluido"] : 'N',
        depositos_eliminados: obj["depositos_eliminados"] ? parseInt(obj["depositos_eliminados"]) : 0,
        inicial_amostra: obj["inicial_amostra"] ? parseInt(obj["inicial_amostra"]) : 0,
        final_amostra: obj["final_amostra"] ? parseInt(obj["final_amostra"]) : 0,
        inspecionado: obj["inspecionado"] ? obj["inspecionado"] : false,
        lado: obj["lado"] ? parseInt(obj["lado"]) : null,
        logradouro: obj["logradouro"] ? obj["logradouro"] : '',
        num_tratamentos: obj["num_tratamentos"] ? parseInt(obj["num_tratamentos"]) : null,
        depositoinspecionado: obj["depositoinspecionado"] ? obj["depositoinspecionado"] : [],
        numero: obj["numero"] ? obj["numero"] : '',
        numeroquadra: obj["numeroquadra"] ? obj["numeroquadra"] : '',
        indice_imovel: obj["indice_imovel"] ? parseInt(obj["indice_imovel"]) : null,
        quantidade_tubitos: obj["quantidade_tubitos"] ? parseInt(obj["quantidade_tubitos"]) : null,
        sem_numero: obj["sem_numero"] ? obj["sem_numero"] : false,
        complemento: obj["complemento"] ? obj["complemento"] : null,
        sgepcategorialocalidade: obj["sgepcategorialocalidade"] ? parseInt(obj["sgepcategorialocalidade"]) : null,
        sgepdenguependencia: obj["sgepdenguependencia"] ? parseInt(obj["sgepdenguependencia"]) : null,
        sgepmotivovisita: obj["sgepmotivovisita"] ? parseInt(obj["sgepmotivovisita"]) : null,
        sgepnomelocalidade: obj["sgepnomelocalidade"] ? parseInt(obj["sgepnomelocalidade"]) : null,
        sgeptipoimovel: obj["sgeptipoimovel"] ? parseInt(obj["sgeptipoimovel"]) : null,
        sgeptipolocal: obj["sgeptipolocal"] ? parseInt(obj["sgeptipolocal"]) : null,
        sgeptipovisita: obj["sgeptipovisita"] ? parseInt(obj["sgeptipovisita"]) : null,
        sgepvisitadengue: obj["sgepvisitadengue"] ? parseInt(obj["sgepvisitadengue"]) : null,
        tratamentoDengue: obj["tratamentoDengue"] ? obj["tratamentoDengue"] : [],
        sgepzona: obj["sgepzona"] ? obj["sgepzona"] : '',
        agentAssistants: obj["agentAssistants"] ? obj["agentAssistants"] : [],
        amostras: obj["amostras"] ? obj["amostras"] : [],
        analisado: obj["analisado"] ? obj["analisado"] : false,
        armadilhas: obj["armadilhas"] ? obj["armadilhas"] : [],
        ano: obj["ano"] ? obj["ano"] : '',
      }
    }
    return new Promise((res, rej) => {

      this.interactor.fetchSave(request, isEndemic).then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

  public fetchDataOne(obj: any): PromiseLike<any> {
    var request = new VisitStructRequest(
      obj["sgepvisita"] ? parseInt(obj["sgepvisita"]) : 0
    )

    return new Promise((res, rej) => {
      this.interactor.fetchDataOne(request).then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

  public fetchProfessional(): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchProfessional().then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

  public fetchVisitReason(id: number): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchVisitReason(id).then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

  public fetchGroupVisitReason(): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchGroupVisitReason().then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

  public fetchLocalityName(): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchLocalityName().then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

  public fetchLocalityCategory(): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchLocalityCategory().then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

  public fetchLocalType(): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchLocalType().then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

  public fetchPropertyType(): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchPropertyType().then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

  public fetchVisitType(): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchVisitType().then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

  public fetchPoison(): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchPoison().then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

  public fetchMunicipality(keyword: string): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchMunicipality(keyword).then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }
  public fetchItensToInspect(): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchItensToInspect().then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }
  public fetchPendencyReason(): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchPendencyReason().then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

  public fetchDengueActivity(): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchDengueActivity().then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }
  public fetchZone(): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchZone().then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

  public fetchTubitType(): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchTubitType().then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

  public fetchSpecies(): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchSpecies().then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

  public fetchMainMunicipality(): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchMainMunicipality().then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }
  public fetchBasicInfo(jsonObj: any): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchBasicInfo(jsonObj).then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

  public fetchLaboratories(): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchLaboratories().then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

  public fetchTrap(): PromiseLike<any> {
    return new Promise((res, rej) => {
      this.interactor.fetchTrap().then((result) => {
        return res(result)
      }, e => {
        return rej(e)
      });
    })
  }

}